import { useQueryClient } from '@tanstack/react-query'
import { getWindLoadsResults, getConfigureWindLoadResults } from '@queries'

const useInvalidateWindLoadResults = () => {
  const queryClient = useQueryClient()

  return async (projectId: string) => {
    await Promise.all([
      queryClient.invalidateQueries(getWindLoadsResults.getKey(projectId)),
      queryClient.invalidateQueries(getConfigureWindLoadResults.getKey(projectId)),
    ])
  }
}

export default useInvalidateWindLoadResults
